import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { pushEnabled, startPush } from '@/lib/push';
import { useAuthStore } from '@/store/auth';
import { useProjectStore } from '@/store/project';

/**
 * Push-уведомления для вошедшего человека (lib/push.ts). Пока флаг
 * PUSH_ENABLED выключен — ничего не делает и плагин даже не грузится.
 * Разрешение спрашивается после входа и загрузки проектов, а не при запуске.
 */
export function PushServices() {
  const navigate = useNavigate();
  const nav = useRef(navigate);
  nav.current = navigate;
  const userId = useAuthStore((s) => s.user?.id ?? null);
  const ready = useProjectStore((s) => s.status === 'ready');

  useEffect(() => {
    if (!userId || !ready || !pushEnabled()) return;
    let stop: (() => void) | null = null;
    let cancelled = false;
    void startPush({
      navigate: (to) => nav.current(to),
      getAccountId: () => {
        const { projects, activeProjectId } = useProjectStore.getState();
        return projects.find((p) => p.id === activeProjectId)?.chatwoot_account_id ?? null;
      },
    }).then((s) => { if (cancelled) s(); else stop = s; });
    return () => { cancelled = true; stop?.(); };
  }, [userId, ready]);

  return null;
}
